export const INITIALISED = 'INITIALISED';
export const SET_CURRENT_PROJECT = 'SET_CURRENT_PROJECT';
export const SET_GETTING_MAP_DATA = 'SET_GETTING_MAP_DATA';
export const SET_MAP_DATA = 'SET_MAP_DATA';
export const SET_GETTING_FEED_DATA = 'SET_GETTING_FEED_DATA';
export const SET_FEED_DATA = 'SET_FEED_DATA';
export const SET_GETTING_EVENT_ACTIVITY_DATA =
  'SET_GETTING_EVENT_ACTIVITY_DATA';
export const SET_EVENT_ACTIVITY_DATA = 'SET_EVENT_ACTIVITY_DATA';
export const FILTER_FEATURES = 'FILTER_FEATURES';
export const SELECT_FEATURE = 'SELECT_FEATURE';
export const CLEAR_FEATURE_SELECTION = 'CLEAR_FEATURE_SELECTION';
export const SET_FILTERS = 'SET_FILTERS';
export const CLEAR_CHART_UPDATED = 'CLEAR_CHART_UPDATED';
